export default __webpack_public_path__ + "static/2018-a9ee5dd26ef0f389a1d7471e19fe0052.png";